import React from 'react'
import Delinquency from './Delinquency'

const delinquencyLayout = () => {
  return (
    <div className="container">
      <Delinquency />
    </div>
  )
}

export default delinquencyLayout
